import { API_TYPES } from '../client/components/ApiDisplay';
import { Category } from '@wix/ambassador-apis-docs-v2-wad/types';

export const isOneOfVeloViewers = (viewerCategory: string) => {
  return isVeloSite(viewerCategory) || isVeloSpisSite(viewerCategory);
};

export const isUserLoggedIn = () => {
  const keys = document.cookie.match(/\w+=/g);
  return keys && keys.includes('wixClient=');
};

export const shouldShowVeloHeader = (viewerCategory: string) =>
  isOneOfVeloViewers(viewerCategory);

export const isVeloSite = (viewerCategory: string) => {
  return viewerCategory === Category.VELO_APIS;
};

export const isVeloSpisSite = (viewerCategory: string) => {
  return viewerCategory === Category.VELO_SPIS;
};

export const getOperationMenuName = (
  name: string,
  layoutType: string,
  JSLayoutType: boolean = false,
) => (layoutType === API_TYPES.JS || JSLayoutType ? `${name}( )` : name);
